import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const carConfigurationSliceName = "carConfiguration";

export interface CarConfigurationState {
  currentPrString: string | null;
  requestedPrString?: string;
}

const initialState: CarConfigurationState = {
  currentPrString: null,
};

const carConfigurationSlice = createSlice({
  name: carConfigurationSliceName,
  initialState,
  reducers: {
    setCurrentPrString(state, action: PayloadAction<string | null>) {
      state.currentPrString = action.payload;
    },
    setRequestedPrString(state, action: PayloadAction<string>) {
      state.requestedPrString = action.payload;
    },
    resetRequestedPrString(state) {
      state.requestedPrString = undefined;
    },
  },
});

export interface CarConfigurationRootState {
  [carConfigurationSliceName]: CarConfigurationState;
}

export const selectCarConfiguration = (state: CarConfigurationRootState) => state[carConfigurationSliceName];
export const selectCurrentPrString = (state: CarConfigurationRootState) => selectCarConfiguration(state).currentPrString;
export const selectRequestedPrString = (state: CarConfigurationRootState) => selectCarConfiguration(state).requestedPrString;

export const { setCurrentPrString, setRequestedPrString, resetRequestedPrString } = carConfigurationSlice.actions;
export const carConfigurationReducer = carConfigurationSlice.reducer;
